<template>
	<div>
		<vs-popup class="holamundo" :title="$t('SerialNumber')" :active.sync="isSerialNumberPopup"
			@close="closeSerialNumberPopup" @cancel="closeSerialNumberPopup">
			<vs-card>
				<b-row class="mb-2">
					<b-col lg="12">
						<b-row class="mb-2">
							<b-col cols="3">{{ $t("SerialNumber") }}</b-col>
							<b-col cols="2" style="padding-right: 0px">{{
								$t("LocalCurrentPrice")
							}}</b-col>
							<b-col cols="1" style="padding-right: 0px">{{
								$t("LocalCurrentCode")
							}}</b-col>
							<b-col cols="2" style="padding-right: 0px">{{ $t("CurrentPrice") }}</b-col>
							<b-col cols="1" style="padding-right: 0px">{{
								$t("CurrentPriceCode")
							}}</b-col>
							<b-col cols="2" style="padding-right: 0px">{{ $t("SellerPrice") }}</b-col>
							<b-col cols="1">{{ $t("SellerCurrentCode") }}</b-col>
						</b-row>

						<b-row class="mb-2" v-for="(item, index) in dataForSerial.serials" :key="index" :id="index">
							<b-col cols="3">
								<b-row>
									<b-col cols="1">{{ "*" + (parseInt(index) + 1) + ": " }}</b-col>
									<b-col>
										<vs-input size="small" v-model="item.value" type="text" class="w-full" name="value" id="value"
											:value="item.value" v-validate="'required'" />
										<p :class="item.status == true ? 'text-success' : 'text-danger'">
											{{ item.status == true ? $t("Saved") : $t("NotSaved") }}
										</p>
									</b-col>
								</b-row>
							</b-col>
							<b-col cols="2" style="padding-right: 0px">
								<vs-input size="small" v-model="item.localCurrentPrice" type="text" class="w-full"
									name="localCurrentPrice" id="localCurrentPrice" :value="item.localCurrentPrice"
									v-validate="'currency'" />
								<span class="text-danger text-sm" v-show="errors.has('localCurrentPrice')">{{
									errors.first("localCurrentPrice") }}</span>
							</b-col>
							<b-col cols="1" style="padding-right: 0px">
								<vs-input size="small" v-model="item.localCurrentCode" type="text" class="w-full"
									name="localCurrentCode" id="localCurrentCode" :value="item.localCurrentCode"
									v-validate="'required'" />
							</b-col>
							<b-col cols="2" style="padding-right: 0px">
								<vs-input size="small" v-model="item.currentPrice" type="text" class="w-full" name="currentPrice"
									id="currentPrice" :value="item.currentPrice" v-validate="'currency'" />
								<span class="text-danger text-sm" v-show="errors.has('currentPrice')">{{
									errors.first("currentPrice")
								}}</span>
							</b-col>
							<b-col cols="1">
								<vs-input size="small" v-model="item.currentPriceCode" type="text" class="w-full"
									name="currentPriceCode" id="currentPriceCode" :value="item.currentPriceCode"
									v-validate="'required'" />
							</b-col>
							<b-col cols="2" style="padding-right: 0px">
								<vs-input size="small" v-model="item.sellerPrice" type="text" class="w-full" name="sellerPrice"
									id="sellerPrice" :value="item.sellerPrice" v-validate="'currency'" />
								<span class="text-danger text-sm" v-show="errors.has('sellerPrice')">{{
									errors.first("sellerPrice")
								}}</span>
							</b-col>
							<b-col cols="1">
								<vs-input size="small" v-model="item.sellerCurrentCode" type="text" class="w-full"
									name="sellerCurrentCode" id="sellerCurrentCode" :value="item.sellerCurrentCode"
									v-validate="'required'" />
							</b-col>
						</b-row>
					</b-col>
					<b-col style="text-align: end">
						<!--      <b-button
            style="border-color: white; width: inherit"
            v-on:click="generateSerialNumbers()"
            size="sm"
            :disabled="dataForSerial.length > 0"
          >
            {{ $t("Generate") }}
          </b-button>-->
						<b-button style="border-color: white" v-on:click="saveSerialNumbers()" class="bg-primary">
							{{ $t("Save") }}
						</b-button>
						<p v-if="!dataForSerial.serialStatus">Henüz kaydolmadı</p>
					</b-col>
				</b-row>
			</vs-card>
		</vs-popup>
		<vs-popup class="holamundo" :title="$t('ProductAccept')" :active.sync="isProductAcceptListPopup">
			<ag-grid-vue style="width: 100%; height: 400px; margin-top: 25px" class="ag-theme-alpine"
				:suppressRowClickSelection="true" :defaultColDef="defaultColDef" :columnDefs="acceptedBarcodesAllColumns"
				:rowData="acceptedBarcodesAll" :localeText="localeText" @grid-ready="onGridReady2">
			</ag-grid-vue>
		</vs-popup>
		<b-row align-v="stretch">
			<b-col lg="9" sm="12" v-if="isMobile()">
				<vs-card>
					<b-row class="justify-content-md-start" style="margin-top: 5px">
						<b-col lg="6" sm="12">
							<p class="mb-0">{{ $t("Company") }}</p>
							<b-row v-if="ROLE != 'Company'">
								<v-select color="danger" v-model="customer" :options="customer_choices" label="name"
									v-on:input="getCustomerDepoList" autocomplete size="large" ref="selectElement" name="customer"
									v-validate="'required'" :disabled="barcodesUpdateControl">
								</v-select>
								<span class="text-danger text-sm" v-show="errors.has('customer')">{{
									errors.first("customer")
								}}</span>
							</b-row>
							<b-row style="margin-top: 15px">
								<p class="mb-0">{{ $t("Supplier") }}</p>
								<v-select color="danger" v-model="supplier" :options="supplier_choices" label="name" autocomplete
									ref="selectElement" name="supplier" :disabled="barcodesUpdateControl">
								</v-select>
							</b-row>
							<b-row style="margin-top: 15px">
								<p class="mb-0">{{ $t("Storehouse") }}</p>
								<v-select color="danger" v-model="storehouse" :options="storehouse_choices"
									:placeholder="$t('Storehouse')" label="name" autocomplete ref="selectElement" name="storehouse"
									v-validate="'required'" v-on:input="getBarcode" :disabled="barcodesUpdateControl">
								</v-select>
								<span class="text-danger text-sm" v-show="errors.has('storehouse')">{{
									errors.first("storehouse")
								}}</span>
							</b-row>
							<b-row style="margin-top: 25px">
								<vs-input v-validate="'required'" data-vv-validate-on="blur" name="username" id="transId" ref="transId"
									:label-placeholder="$t('TransactionNo')" v-model="transactionNo" class="w-full"
									@keyup.enter="transactionNoCntrl" :disabled="barcodesUpdateControl" />
							</b-row>
							<b-row style="margin-top: 15px">
								<b-form-group label-for="item-name">
									<p class="mb-0">{{ $t("Description") }}</p>

									<vs-textarea v-model="transactionDescription" />
								</b-form-group>
							</b-row>
							<b-row style="margin-top: 15px">
								<p class="mb-0">{{ $t("Quantity") }}</p>

								<v-select color="danger" v-model="selectedPerQty" :options="perQty" label="name" ref="selectElement"
									name="perQty" :taggable="true">
								</v-select>
							</b-row>
							<b-row style="margin-top: 15px">
								<p class="mb-0">{{ $t("TransType") }}</p>

								<v-select color="danger" v-model="transType" :options="transType_choices" label="name" autocomplete
									ref="selectElement" name="transType" v-validate="'required'"
									:disabled="barcodesUpdateControl || transTypeDisabled">
								</v-select>
								<span class="text-danger text-sm" v-show="errors.has('transType')">{{
									errors.first("transType")
								}}</span>
							</b-row>
							<b-row style="margin-top: 15px">
								<p class="mb-0">{{ $t("Stockno") }}</p>

								<div style="height: 95%">
									<input id="barcodeId" ref="barcodeId" v-model="stockno" @keyup.enter="filterStock"
										@input="stockNoValidate" @focus="handleFocus(1)" autocomplete="off" style="
                      padding: 0px;
                      margin: 0px;
                      width: 50px;
                      position: absolute;
                      width: 300px;
                      height: 200px;
                      opacity: 0;
                    " />
									<b-row style="text-align: center; margin: 10px">
										<b-col>
											<Icon icon="bi:upc-scan" style="margin-right: 5px" width="150" height="150" />
										</b-col>
									</b-row>
								</div>
							</b-row>
						</b-col>
					</b-row>
				</vs-card>
			</b-col>
			<b-col lg="9" sm="12" v-else>
				<vs-card>
					<b-row class="justify-content-md-start" style="margin-top: 5px">
						<b-col lg="6" sm="12">
							<b-row v-if="ROLE != 'Company'">
								<b-col cols="5" style="text-align: start" align-self="center">
									<b-form-group style="font-size: small; font-weight: bold" :label="'* ' + $t('Customer')"
										label-for="h-first-name">
									</b-form-group>
								</b-col>
								<b-col>
									<v-select color="danger" v-model="customer" :options="customer_choices" size="small" label="name"
										v-on:input="getCustomerDepoList" autocomplete ref="selectElement" name="customer"
										v-validate="'required'" :disabled="barcodesUpdateControl">
									</v-select>
									<span class="text-danger text-sm" v-show="errors.has('customer')">{{
										errors.first("customer")
									}}</span>
								</b-col>
							</b-row>
							<b-row style="margin-top: 5px">
								<b-col cols="5" style="text-align: start" align-self="center">
									<b-form-group style="font-size: small; font-weight: bold" :label="$t('Supplier')"
										label-for="h-first-name">
									</b-form-group>
								</b-col>
								<b-col>
									<v-select color="danger" v-model="supplier" :options="supplier_choices" size="small" label="name"
										autocomplete ref="selectElement" name="supplier" :disabled="barcodesUpdateControl">
									</v-select>
								</b-col>
							</b-row>
							<b-row style="margin-top: 5px">
								<b-col cols="5" style="text-align: start" align-self="center">
									<b-form-group style="font-size: small; font-weight: bold" :label="'* ' + $t('Storehouse')"
										label-for="h-first-name">
									</b-form-group>
								</b-col>
								<b-col>
									<v-select color="danger" v-model="storehouse" :options="storehouse_choices" size="small" label="name"
										autocomplete ref="selectElement" name="storehouse" v-validate="'required'" v-on:input="getBarcode"
										:disabled="barcodesUpdateControl">
									</v-select>
									<span class="text-danger text-sm" v-show="errors.has('storehouse')">{{
										errors.first("storehouse")
									}}</span>
								</b-col>
							</b-row>
							<b-row style="margin-top: 5px">
								<b-col cols="5" style="text-align: start" align-self="center">
									<b-form-group style="font-size: small; font-weight: bold" :label="'* ' + $t('TransactionNo')"
										label-for="h-first-name">
									</b-form-group>
								</b-col>
								<b-col align-self="center">
									<b-form-group label-for="item-name">
										<b-form-input id="transId" ref="transId" v-model="transactionNo" @keyup.enter="transactionNoCntrl"
											:disabled="barcodesUpdateControl" />
									</b-form-group>
								</b-col>
							</b-row>
							<b-row style="margin-top: 5px">
								<b-col cols="5" style="text-align: start">
									<b-form-group style="font-size: small; font-weight: bold" :label="$t('Description')"
										label-for="h-first-name">
									</b-form-group>
								</b-col>
								<b-col>
									<b-form-group label-for="item-name">
										<vs-textarea v-model="transactionDescription" />
									</b-form-group>
								</b-col>
							</b-row>
						</b-col>

						<b-col lg="6" sm="12">
							<b-row>
								<b-col cols="4" style="text-align: start" align-self="center">
									<b-form-group style="font-size: small; font-weight: bold" :label="'* ' + $t('Quantity')"
										label-for="h-first-name">
									</b-form-group>
								</b-col>
								<b-col>
									<b-form-group label-for="item-name">
										<v-select color="danger" v-model="selectedPerQty" :options="perQty" size="small" label="name"
											ref="selectElement" name="perQty" :taggable="true">
										</v-select>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row style="margin-top: 5px">
								<b-col cols="4" style="text-align: start" align-self="center">
									<b-form-group style="font-size: small; font-weight: bold" :label="'* ' + $t('TransType')"
										label-for="h-first-name">
									</b-form-group>
								</b-col>
								<b-col>
									<v-select color="danger" v-model="transType" :options="transType_choices" size="small" label="name"
										autocomplete ref="selectElement" name="transType" v-validate="'required'"
										:disabled="barcodesUpdateControl || transTypeDisabled">
									</v-select>
									<span class="text-danger text-sm" v-show="errors.has('transType')">{{
										errors.first("transType")
									}}</span>
								</b-col>
							</b-row>
							<b-row style="margin-top: 5px">
								<b-col cols="4" style="text-align: start" align-self="center">
									<b-form-group style="font-size: small; font-weight: bold" :label="'* ' + $t('Barcode')"
										label-for="h-first-name">
									</b-form-group>
								</b-col>
								<b-col>
									<b-form-group label-for="item-name">
										<b-form-input id="barcodeId" ref="barcodeId" v-model="stockno" @input="stockNoValidate"
											:placeholder="$t('Stockno')" @keyup.enter="filterStock" />
									</b-form-group>
								</b-col>
							</b-row>
							<!--
              <b-row v-if="barcode_choices.length > 0" style="margin-top: 5px">
                <b-col cols="4" style="text-align: start" align-self="center">
                  <b-form-group
                    style="font-size: medium"
                    :label="'* ' + $t('Storehouse')"
                    label-for="h-first-name"
                  >
                  </b-form-group>
                </b-col>
                <b-col>
                  <v-select
                    color="danger"
                    v-model="barcodeCh"
                    :options="barcode_choices"
                    size="small"
                    label="name"
                    autocomplete
                    ref="selectElement"
                    name="storehouse"
                    v-on:input="
                      stockno = barcodeCh.code;
                      filterStock();
                    "
                  >
                  </v-select>
                </b-col>
              </b-row>-->
						</b-col>
					</b-row>
				</vs-card>
			</b-col>
			<b-col>
				<vs-card style="height: 91%">
					<b-row style="margin-top: 5px">
						<b-col>
							<b-row class="justify-content-md-end">
								<b-col>
									<b-button style="border-color: white; width: 100%" v-on:click="isSidebarActiveProcess = true"
										size="lg" class="vs-con-loading__container bg-primary" id="loading-acceptence-list">
										<vs-chip>{{ totalQEntery }}</vs-chip>

										<Icon icon="fluent-mdl2:completed" width="20" height="20" />
										{{ $t("CompleteProcess") }}
									</b-button></b-col>
							</b-row>
							<b-row class="justify-content-md-end" style="margin-top: 5px" v-if="!isMobile()">
								<b-col>
									<b-button class="bg-primary" style="border-color: white; width: 100%" v-on:click="
										uploadMethod = 'addNewWithExcel';
									isSidebarActiveAddWithExcel = true;
									">
										<Icon icon="icon-park-outline:excel" width="20" height="20" />
										{{ $t("AddWithExcel") }}
									</b-button>
								</b-col>
							</b-row>
							<b-row class="justify-content-md-end" style="margin-top: 5px">
								<b-col>
									<b-button class="bg-danger" style="border-color: white; width: 100%" v-on:click="deleteAllList()"
										size="sm">
										<Icon icon="ic:baseline-remove-circle" width="20" height="20" />
										{{ $t("deleteAllList") }}
									</b-button>
								</b-col>
							</b-row>

							<b-row class="justify-content-md-end" style="margin-top: 5px" v-if="!isMobile()">
								<b-col>
									<b-button class="bg-warning" style="border-color: white; width: 100%" v-on:click="
										uploadMethod = 'excelData';
									isSidebarActiveCheckExcel = true;
									">
										<Icon icon="mdi:file-excel-outline" width="20" height="20" />
										{{ $t("CheckWithExcel") }}
									</b-button></b-col>
							</b-row>
							<b-row class="justify-content-md-end" style="margin-top: 5px">
								<b-col>
									<b-button class="bg-success" style="border-color: white; width: 100%"
										v-on:click="productAcceptedList()">
										<Icon icon="ep:list" width="20" height="20" />
										{{ $t("productAcceptedList") }}
									</b-button>
								</b-col>
							</b-row>
							<b-row class="justify-content-md-end" style="margin-top: 5px" v-if="!isMobile()">
								<b-col>
									<b-button class="bg-warning" style="border-color: white; width: 100%" v-on:click="printBarcode(true)"
										size="sm">
										<Icon icon="material-symbols:print-outline" width="20" height="20" />
										{{ $t("printSerialNumber") }}
									</b-button>
								</b-col>
							</b-row>
						</b-col>
					</b-row>
				</vs-card>
			</b-col>
		</b-row>

		<b-row>
			<b-col>
				<vs-card>
					<ag-grid-vue style="width: 100%; height: 400px; margin-top: 25px" class="ag-theme-alpine"
						:suppressRowClickSelection="true" :defaultColDef="defaultColDef" :columnDefs="acceptedBarcodesColumns"
						:rowData="acceptedBarcodes" :localeText="localeText" @grid-ready="onGridReady">
					</ag-grid-vue>
				</vs-card>
			</b-col>
		</b-row>
		<DeleteWarning :isPromptActive="deleteWarningPromptValid" :data="deleteData" />
		<vs-popup class="holamundo" :title="$t('PrintBarcode')" :active.sync="isSidebarActiveBarcodePrintTemp"
			@close="printBarcode" @cancel="printBarcode" fullscreen>
			<BarcodePrintingTamplate :isSidebarActive="isSidebarActiveBarcodePrintTemp" :name="'serialNumberTemplate'"
				:data="printAcceptedValues" @closeSidebar="printBarcode" />
		</vs-popup>
		<vs-prompt :title="$t('Warning')" :acceptText="$t('Submit')" :cancelText="$t('Cancel')"
			@accept="deleteAcceptedBarcode" :active.sync="isSidebarActiveDeleteFromList" color="danger">
			<div style="text-align: center" class="con-exemple-prompt">
				<span>
					<b-row style="margin-top: 15px">
						<b-col cols="12" align-self="center">
							<h6>{{ $t("DoConfirm") }}</h6>
						</b-col>
					</b-row>
				</span>
			</div>
		</vs-prompt>
		<vs-prompt :title="$t('Warning')" :acceptText="$t('Submit')" :cancelText="$t('Cancel')" @accept="completeProcess"
			:active.sync="isSidebarActiveProcess" color="primary">
			<div style="text-align: center" class="con-exemple-prompt">
				<span>
					<b-row style="margin-top: 15px">
						<b-col cols="12" align-self="center">
							<h6>{{ $t("DoConfirm") }}</h6>
						</b-col>
					</b-row>
				</span>
			</div>
		</vs-prompt>
		<vs-popup class="holamundo" :title="$t('AddWithExcel')" :active.sync="isSidebarActiveAddWithExcel"
			@close="closeExcelAddPopup" @cancel="closeExcelAddPopup" fullscreen>
			<vs-prompt :title="$t('Submit')" :acceptText="$t('Save')" :cancelText="$t('Cancel')" @accept="addProductWithExcel"
				:active.sync="activePromptToProduct">
				<div class="con-exemple-prompt">
					<b-row style="align-items: center">
						<b-col lg="12">
							<span>{{ $t("ConfirmToUpdateList") }} {{ $t("AreYSure") }}
								{{ $t("CantUndo") }}</span>
						</b-col>
					</b-row>
				</div>
			</vs-prompt>
			<vs-prompt :title="$t('Submit')" :cancelText="$t('Cancel')" :active.sync="excelLogList">
				<div class="con-exemple-prompt">
					<b-row style="align-items: center">
						<b-col lg="12"> 
							<vs-table :data="errorExcels">
								<template slot="thead">
									<vs-th sort-key="barcode">{{ $t("barcode") }} </vs-th>
									<vs-th sort-key="serialParam">{{
										$t("serialParam")
									}}</vs-th>
									<vs-th sort-key="message">{{
										$t("message")
									}}</vs-th>

								</template>

								<template slot-scope="{ data }">
									<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
										<vs-td :data="data[indextr].barcode">
											{{ data[indextr].barcode }}
										</vs-td>
										<vs-td :data="data[indextr].serialParam">
											{{ data[indextr].serialParam }}
										</vs-td>
										<vs-td :data="data[indextr].message">
											{{ data[indextr].message }}
										</vs-td>

									</vs-tr>
								</template>
							</vs-table>
						</b-col>
					</b-row>
				</div>
			</vs-prompt>
			<b-row>
				<b-col lg="6">
					<vs-card>
						<b-row class="mb-8 mt-8">
							<UploadBtnDynamic :isUploaded="isUploadedAddExcel" :uploadMethod="uploadMethod" />
						</b-row>
						<b-row class="justify-content-md-end">
							<b-col cols="12" md="auto" class="ml-2" style="padding: 0px">
								<b-button class="bg-danger" style="border-color: white" v-on:click="excelLogList = true">
									<Icon icon="material-symbols:cancel-outline" style="margin-right: 5px" width="20" height="20" />{{
										$t("ExcelLogList") }}
								</b-button>
							</b-col>
							<b-col cols="12" md="auto" class="ml-2" style="padding: 0px">
								<b-button class="bg-danger" style="border-color: white" v-on:click="clearAddExcel()">
									<Icon icon="material-symbols:cancel-outline" style="margin-right: 5px" width="20" height="20" />{{
										$t("Cancel") }}
								</b-button>
							</b-col>
							<b-col cols="12" md="auto" style="padding: 0px">
								<b-button class="bg-success" style="border-color: white" v-on:click="downloadSampleAddExcel()">
									{{ $t("SampleExcel") }}</b-button>
							</b-col>
							<b-col cols="12" md="auto" style="padding: 0px">
								<b-button class="bg-primary" style="border-color: white" v-on:click="activePromptToProduct = true">
									{{ $t("Add") }}
								</b-button></b-col>
						</b-row>
					</vs-card>
				</b-col>
				<b-col>
					<b-row>
						<b-col>
							<vs-card>
								<ag-grid-vue style="width: 100%; height: 400px" class="ag-theme-alpine"
									:suppressRowClickSelection="true" :defaultColDef="defaultColDef" :columnDefs="excelListColumnAdd"
									:rowData="wholeAcceptedProductListAddExcel" :localeText="localeText" @grid-ready="onGridReady">
								</ag-grid-vue>
							</vs-card>
						</b-col>
					</b-row>
				</b-col>
			</b-row>
		</vs-popup>
		<vs-popup class="holamundo" :title="$t('CheckWithExcel')" :active.sync="isSidebarActiveCheckExcel"
			@close="closeExcelPopup" @cancel="closeExcelPopup" fullscreen>
			<b-row>
				<b-col lg="4">
					<vs-card>
						<b-row class="mb-8 mt-8">
							<UploadBtnDynamic :isUploaded="isUploaded" :uploadMethod="uploadMethod" />
						</b-row>
						<b-row class="justify-content-md-end">

							<b-col cols="12" md="auto" class="ml-2" style="padding: 0px">
								<b-button class="bg-danger" style="border-color: white" v-on:click="clear()">
									<Icon icon="material-symbols:cancel-outline" style="margin-right: 5px" width="20" height="20" />{{
										$t("Cancel") }}
								</b-button>
							</b-col>
							<b-col cols="12" md="auto" style="padding: 0px">
								<b-button class="bg-success" style="border-color: white" v-on:click="downloadSample()">
									{{ $t("SampleExcel") }}</b-button>
							</b-col>
							<b-col cols="12" md="auto" style="padding: 0px">
								<b-button class="bg-primary" style="border-color: white" v-on:click="compareProduct()">
									{{ $t("Compare") }}
								</b-button>
							</b-col>
						</b-row>
					</vs-card>
				</b-col>
				<b-col>
					<b-row>
						<b-col>
							<vs-card>
								<h4>{{ $t("ExcelListInfo1") }}</h4>
								<ag-grid-vue style="width: 100%; height: 400px" class="ag-theme-alpine"
									:suppressRowClickSelection="true" :defaultColDef="defaultColDef" :columnDefs="excelListColumn1"
									:rowData="notInList" :localeText="localeText" @grid-ready="onGridReady">
								</ag-grid-vue>
							</vs-card>
						</b-col>
						<b-col>
							<vs-card>
								<h4>{{ $t("ExcelListInfo2") }}</h4>
								<ag-grid-vue style="width: 100%; height: 400px" class="ag-theme-alpine"
									:suppressRowClickSelection="true" :defaultColDef="defaultColDef" :columnDefs="excelListColumn2"
									:rowData="notInExcel" :localeText="localeText" @grid-ready="onGridReady">
								</ag-grid-vue>
							</vs-card>
						</b-col>
					</b-row>
				</b-col>
			</b-row>
		</vs-popup>
	</div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import i18nData from "../../i18n/i18nData";
import vSelect from "vue-select";
import { Icon } from "@iconify/vue2";
import moment from "moment";
import TextViewCellRenderer from "../CellRenderers/TextViewCellRenderer.vue";
import twoInfoButtonsDynamic from "../CellRenderers/twoInfoButtonsDynamic.vue";
import threeInfoButtonsDynamic from "../CellRenderers/threeInfoButtonsDynamic.vue";
import { isMobile } from "mobile-device-detect";

import DeleteWarning from "../../components/warning-message/DeleteWarning.vue";
import stockAcceptancedCount from "./CellRenderers/stockAcceptancedCount.vue";
import { Validator } from "vee-validate";
import XLSX from "xlsx";
import UploadBtnDynamic from "../components/global-components/UploadBtnDynamic.vue";
import userJson from "../../../public/user.json";
import BarcodePrintingTamplate from "../components/global-components/BarcodePrintingTamplate.vue";
Validator.extend("currency", {
	getMessage: (field) => `${field} geçerli bir para birimi olmalıdır.`,
	validate: (value) => {
		const regex = /^\d+(\.\d{1,2})?$/; // Ondalık 2 hane destekler, örn: 123.45
		return regex.test(value);
	},
});
export default {
	components: {
		BarcodePrintingTamplate,
		stockAcceptancedCount,
		DeleteWarning,
		twoInfoButtonsDynamic,
		threeInfoButtonsDynamic,
		TextViewCellRenderer,
		Icon,
		vSelect,
		AgGridVue,
		UploadBtnDynamic,
	},

	data() {
		return {
			excelLogList: false,
			totalQEntery: 0,
			isMobile: function () {
				return isMobile;
			},
			sellerCurrentCode: "",
			sellerPrice: 0,
			isSidebarActiveBarcodePrintTemp: false,
			isSerialNumberPopup: false,
			supplier: "",
			supplier_choices: [],
			transTypeDisabled: false,
			transType_choices: "",
			transType: "",
			barcodeCh: "",
			barcode_choices: "",
			isSidebarActiveDeleteFromList: false,
			activePromptToProduct: false,
			uploadMethod: "",
			isUploaded: false,
			isUploadedAddExcel: false,
			excelListColumn1: [],
			excelListColumn2: [],
			excelListColumnAdd: [],
			notInList: [],
			notInExcel: [],
			excelListAdd: [],
			isSidebarActiveAddWithExcel: false,
			isSidebarActiveCheckExcel: false,
			acceptedBarcodesAll: [],
			acceptedBarcodesAllColumns: [],
			isProductAcceptListPopup: false,
			isSidebarActiveProcess: false,
			deleteWarningPromptValid: false,
			selectedPerQty: 1,
			perQty: [1, 10, 50, 100, 200, 300, 500, 1000],
			barcodesUpdateControl: false,
			acceptedBarcodesColumns: [],
			defaultColDef: {
				sortable: true,
				editable: true,
				resizable: true,
			},
			transactionNo: "",
			transactionDescription: "",
			stockno: "",
			storehouse: "",
			storehouse_choices: [],
			ROLE: this.$store.state.AppActiveUser.ROLE,
			customer: "",
			customerListOption: [],
			customer_choices: [],
			deleteData: [{}],
			wholeAcceptedProductList: [],
			wholeAcceptedProductListAddExcel: [],
			isInfoForValidate: false,
			deletedData: [],
			dataForSerial: [],
			printAcceptedValues: [],
			firstInputFocused: false,
			errorExcels: []
		};
	},
	methods: {
		keepFocus() {
			this.$nextTick(() => {
				if (this.currentFocusedInput === 1) {
					this.$refs.barcodeId.focus();
				}
			});
		},
		handleFocus(inputNumber) {
			if (inputNumber === 1 && !this.firstInputFocused) {
				this.currentFocusedInput = 1;
				this.firstInputFocused = true;
			} else if (inputNumber === this.currentFocusedInput) {
				return;
			} else if (inputNumber !== 1) {
				this.currentFocusedInput = inputNumber;
			}
			this.keepFocus();
		},
		printBarcode(val = false) {
			// this.isSidebarActiveBarcodePrintTemp = val;
		},
		closeSerialNumberPopup() {
			this.dataForSerial = [];
		},
		saveSerialNumbers() {
			this.updateSerialInCart();
			this.isSerialNumberPopup = false;
		},
		updateSerialInCart() {
			this.dataForSerial.serials.forEach((val, index) => {
				this.dataForSerial.serials[index] = {
					value: val.value,
					status: true,
					currentPrice: val.currentPrice,
					localCurrentPrice: val.localCurrentPrice,
					localCurrentCode: val.localCurrentCode,
					currentPriceCode: val.currentPriceCode,
					sellerCurrentCode: val.sellerCurrentCode,
					sellerPrice: val.sellerPrice,
				};
			});
			let obj = {
				barcode: this.dataForSerial.barcode,
				serials: this.dataForSerial.serials,
			};
			this.$store.commit("stock/UPDATE_ACCEPTED_BARCODES_SERIAL", obj);
			setTimeout(() => {
				document.getElementById("barcodeId").focus();
			}, 500);
		},
		generateSerialNumbers() {
			try {
				if (
					this.dataForSerial.serialStatus == false ||
					this.dataForSerial.serialStatus == null
				) {
					this.dataForSerial.serials = [];
				}

				for (let i = 0; i < this.dataForSerial.qEntery; i++) {
					if (
						this.dataForSerial.serialStatus == false ||
						this.dataForSerial.serialStatus == null
					) {
						let baseCode = this.generateRandomNumber(12);
						let checkDigit = this.calculateCheckDigit(baseCode);
						this.dataForSerial.serials.push({
							value: baseCode + checkDigit,
							status: false,
							currentPrice: 0,
							localCurrentPrice: 0,
							localCurrentCode: "TL",
							currentPriceCode: "",
							sellerCurrentCode: "",
							sellerPrice: 0,
						});
					} else {
						if (typeof this.dataForSerial.serials[i] == "undefined") {
							if (this.dataForSerial.qEntery > this.dataForSerial.serials.length) {
								let baseCode = this.generateRandomNumber(12);
								let checkDigit = this.calculateCheckDigit(baseCode);

								this.dataForSerial.serials.push({
									value: baseCode + checkDigit,
									status: false,
									currentPrice: 0,
									localCurrentPrice: 0,
									localCurrentCode: "TL",
									currentPriceCode: "",
									sellerCurrentCode: "",
									sellerPrice: 0,
								});
							}
						} else {
							if (this.dataForSerial.qEntery < this.dataForSerial.serials.length) {
								this.dataForSerial.serials.splice(
									this.dataForSerial.serials.length - this.dataForSerial.qEntery,
									this.dataForSerial.serials.length
								);
							}
						}
					}
				}
			} catch (error) {
				console.log(error);
			}
		},
		generateRandomNumber(length) {
			let result = "";
			result += Math.floor(Math.random() * 9) + 1;
			for (let i = 1; i < length; i++) {
				result += Math.floor(Math.random() * 10);
			}
			return result;
		},
		calculateCheckDigit(code) {
			let sum = 0;
			for (let i = 0; i < code.length; i++) {
				let num = parseInt(code[i]);
				sum += i % 2 === 0 ? num : num * 3;
			}
			let remainder = sum % 10;
			return remainder === 0 ? 0 : 10 - remainder;
		},
		getSupplierList() {
			this.supplierListOption = [];
			this.supplier_choices = [];
			this.supplierListOption = this.supplierLc;
			this.supplierListOption.forEach((val, index) => {
				this.supplier_choices.push({
					value: val.SupplierId,
					name: val.SupplierName,
					code: val.SupplierCode,
				});
			});
		},
		stockNoValidate() {
			this.stockno = this.stockno.replace(/\?/g, "_").replace(/ı/g, "i");
		},
		isInfoFor(val = false) {
			this.isInfoForValidate = val;
		},
		clearAddExcel() {
			this.wholeAcceptedProductListAddExcel = [];
			this.isUploadedAddExcel = false;
		},
		clear() {
			this.wholeAcceptedProductList = [];
			this.isUploaded = false;
		},
		downloadSampleAddExcel() {
			const link = document.createElement("a");
			link.href = userJson.assetsUrl + "ProductAcceptanceSample.xlsx";
			link.download = "SampleProductAcceptanceTemplate.xlsx";
			link.click();
		},
		downloadSample() {
			const link = document.createElement("a");
			link.href = userJson.assetsUrl + "SampleProductAcceptanceTemplate.xlsx";
			link.download = "SampleProductAcceptanceTemplate.xlsx";
			link.click();
		},
		addProductWithExcel() {
			const vs = this.$vs;

			if (this.transactionNo == "") {
				vs.notify({
					text: this.$t("InfoTransferNo"),
					iconPack: "feather",
					icon: "icon-alert-circle",
					color: "warning",
					position: "top-center",
				});
			} else {
				this.errorExcels = []
				this.filterStockExcel(this.wholeAcceptedProductListAddExcel.length - 1);
				console.log(this.errorExcels)
				//if (this.errorExcels.length > 0) this.excelLogList = true
			}
		},
		setItem() {
			this.excelListColumnAdd = [];
			let columnList = Object.keys(this.wholeAcceptedProductListAddExcel[0]);
			columnList.forEach((value, index) => {
				this.excelListColumnAdd.push({
					headerName: this.$t(value),
					field: value,
					filter: "agSetColumnFilter",
				});
			});
		},
		filterStockExcel(index) {
			const vs = this.$vs;
			if (index == -1) {
				vs.notify({
					text: this.$t("Added"),
					iconPack: "feather",
					icon: "icon-alert-circle",
					color: "success",
					position: "top-center",
				});
			} else {
				this.isInCart(this.wholeAcceptedProductListAddExcel[index].barcode)
					? this.updateBarcodeInCart(
						"excel",
						this.wholeAcceptedProductListAddExcel[index].barcode,
						this.wholeAcceptedProductListAddExcel[index].quantity,
						this.wholeAcceptedProductListAddExcel[index]
					)
					: this.addBarcodeInCart(
						"excel",
						this.wholeAcceptedProductListAddExcel[index].barcode,
						this.wholeAcceptedProductListAddExcel[index].quantity,
						this.wholeAcceptedProductListAddExcel[index]
					);
				index--;
				this.filterStockExcel(index);
			}
		},
		compareProduct() {
			const resultIn = [];
			this.excelListColumn1 = [];
			this.excelListColumn2 = [];

			this.wholeAcceptedProductList.forEach((value, index) => {
				this.acceptedBarcodes.forEach((val2, ind) => {
					if (value.barcode == val2.barcode && value.quantity == val2.qEntery) {
						resultIn.push(val2);
					}
				});
			});

			this.notInExcel = [];
			this.notInList = [];
			const barcodesInJson2 = resultIn.map((item) => item.barcode);
			const uniqueBarcodesInJson1 = this.wholeAcceptedProductList.filter((item) => {
				return !barcodesInJson2.includes(String(item.barcode)); // Burada return ekledik
			});
			const uniqueBarcodesInJson2 = this.acceptedBarcodes.filter((item) => {
				return !barcodesInJson2.includes(String(item.barcode)); // Burada return ekledik
			});

			this.notInList = uniqueBarcodesInJson2;
			this.notInExcel = uniqueBarcodesInJson1;
			let columnList = Object.keys(this.notInList[0]);
			let columnListE = Object.keys(this.notInExcel[0]);

			columnList.forEach((value, index) => {
				if (value == "barcode" || value == "qEntery")
					this.excelListColumn1.push({
						headerName: this.$t(value),
						field: value,
						filter: "agSetColumnFilter",
					});
			});
			columnListE.forEach((value, index) => {
				if (value == "barcode" || value == "quantity")
					this.excelListColumn2.push({
						headerName: this.$t(value),
						field: value,
						filter: "agSetColumnFilter",
					});
			});
		},
		closeExcelAddPopup() {
			this.isSidebarActiveAddWithExcel = false;
			this.isUploadedAddExcel = false;
			this.wholeAcceptedProductListAddExcel = [];
		},
		closeExcelPopup() {
			this.isSidebarActiveCheckExcel = false;
			this.excelListColumn1 = [];
			this.excelListColumn2 = [];
			this.notInList = [];
			this.notInExcel = [];
			this.wholeAcceptedProductList = [];
			this.isUploaded = false;
		},
		parseDate(params) {
			return moment(String(params)).format("YYYY-MM-DD");
		},
		productAcceptedList() {
			window.open(this.$router.resolve({ name: "inventory-movements" }).href, "_blank");
		},
		completeProcess() {
			const vs = this.$vs;
			for (let i = 0; i < this.acceptedBarcodes.length; i++) {
				this.acceptedBarcodes.description = this.transactionDescription;
			}
			if (this.acceptedBarcodes.length == 0)
				vs.notify({
					text: this.$t("Validate"),
					iconPack: "feather",
					icon: "icon-alert-circle",
					color: "warning",
					position: "top-center",
				});
			else {
				let type = "material";

				setTimeout(() => {
					vs.loading({
						container: `#loading-acceptence-list`,
						type,
						scale: 0.5,
					});
				}, 500);

				/*    this.$validator.validateAll().then((result) => {
					if (result) {*/
				let acceptedBarcodesObj = [];
				this.acceptedBarcodes.forEach((val, index) => {
					if (val.SerialFollow == true) {
						val.serials.forEach((serino, ind) => {
							val.qEntery = 1;

							// Her iterasyonda yeni bir obje oluştur
							const newVal = JSON.parse(JSON.stringify(val));

							newVal.serialInfo = {
								stockTransPriceInfoId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
								serialNumber: serino.value,
								localCurrentCode: serino.localCurrentCode
									? serino.localCurrentCode
									: "TL",
								localCurrentPrice: serino.localCurrentPrice
									? serino.localCurrentPrice
									: 0,
								currentPriceCode: serino.currentPriceCode ? serino.currentPriceCode : "",
								currentPrice: serino.currentPrice ? serino.currentPrice : 0,
								sellerCurrentCode: serino.sellerCurrentCode
									? serino.sellerCurrentCode
									: "",
								sellerPrice: serino.sellerPrice ? serino.sellerPrice : 0,
							};

							acceptedBarcodesObj.push(newVal);
						});
					} else {
						acceptedBarcodesObj.push(val);
					}
				});
				this.$store
					.dispatch("stock/addStockTrans", acceptedBarcodesObj)
					.then((response) => {
						if (response.success == true) {
							vs.notify({
								text: response.message,
								iconPack: "feather",
								icon: "icon-alert-circle",
								color: "success",
								position: "top-center",
							});
							setTimeout(() => {
								vs.loading.close("#loading-acceptence-list > .con-vs-loading");
							}, 1000);
							this.printControlForSerial();
						} else {
							setTimeout(() => {
								vs.loading.close("#loading-acceptence-list > .con-vs-loading");
							}, 1000);
							vs.notify({
								text: response.data.message.toString(),
								iconPack: "feather",
								icon: "icon-alert-circle",
								color: "danger",
								position: "top-center",
							});
						}
					})
					.catch((error) => {
						setTimeout(() => {
							vs.loading.close("#loading-acceptence-list > .con-vs-loading");
						}, 1000);
						console.log(error);
						vs.notify({
							text: error.toString(),
							iconPack: "feather",
							icon: "icon-alert-circle",
							color: "danger",
							position: "top-center",
						});
					});
				/*  } else {
						vs.notify({
							text: this.$t("Validate"),
							iconPack: "feather",
							icon: "icon-alert-circle",
							color: "warning",
							position: "top-center",
						});
					}
				});*/
			}
		},
		closeDeleteWarning() {
			this.deleteWarningPromptValid = false;
		},
		printControlForSerial() {
			this.printAcceptedValues = [];
			this.acceptedBarcodes.forEach((val, index) => {
				if (val.SerialFollow) {
					val.serials.forEach((val2, index2) => {
						this.printAcceptedValues.push({
							serialNo: val2.value,
							localCurrentPrice: val2.localCurrentPrice,
							localCurrentCode: val2.localCurrentCode,
							currentPrice: val2.currentPrice,
							currentPriceCode: val2.currentPriceCode,
							sellerCurrentCode: val2.sellerCurrentCode,
							sellerPrice: val2.sellerPrice,
							companyId: val.companyId,

							SerialFollow: val.SerialFollow,
							StockName: val.StockName,
							Stockno: val.Stockno,
							Barcode: val.barcode,
							CompanyName: val.companyName,
							CreateDate: val.createDate,
							DepotName: val.depotName,
							Description: val.description,
							GroupCode: val.groupCode,
							QEntery: val.qEntery,
							QExit: val.qExit,
							SpecCode1: val.specCode1,
							SpecCode2: val.specCode2,
							SupplierCode: val.supplierCode,
							SupplierName: val.supplierName,
							TransCode: val.transCode,
							TransDate: val.transDate,
							TransTypeName: val.transTypeName,
							TrasnType: val.trasnType,
						});
					});
				}
			});

			if (this.printAcceptedValues.length > 0) this.printBarcode(true);
			this.deleteAll();
		},
		deleteAll() {
			this.$store.commit("stock/REMOVE_ACCEPTED_ALL_BARCODES");
			this.stockno = "";
			this.storehouse = "";
			this.customer = "";
			this.transactionNo = "";
			this.supplier = "";
			if (this.$route.path == "/product-receipt") {
				this.transType = {
					value: "1",
					name: this.$t("Entrance"),
				};
				this.transTypeDisabled = true;
			} else this.transType = "";

			this.transactionDescription = "";
			this.barcodesUpdateControl = false;
			this.closeDeleteWarning();
		},
		deleteAllList() {
			this.deleteWarningPromptValid = true;
		},
		deleteAcceptedBarcode() {
			let obj = {
				barcode: this.deletedData.barcode,
				serial: this.deletedData.serials,
			};
			if (this.deletedData.SerialFollow)
				this.$store.commit("stock/REMOVE_ACCEPTED_BARCODES_EXCEL", obj);
			else this.$store.commit("stock/REMOVE_ACCEPTED_BARCODES", obj);
		},
		transactionNoCntrl() {
			setTimeout(() => {
				document.getElementById("barcodeId").focus();
			}, 500);
		},
		parseDate(params) {
			return moment(String(params)).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
		},
		parseDateAg(params) {
			return moment(String(params.value)).format("YYYY-DD-MM");
		},
		getBarcode() {
			setTimeout(() => {
				document.getElementById("transId").focus();
			}, 500);
		},
		updateBarcodeInCart(isDue, barcode, quantity) {
			let obj = {};
			let baseCode = this.generateRandomNumber(12);
			let checkDigit = this.calculateCheckDigit(baseCode);
			let contBarc = isDue == "excel" ? barcode : this.stockno;
			const index = this.acceptedBarcodes.findIndex((i) => i.barcode == contBarc);
			if (this.acceptedBarcodes[index].SerialFollow == true)
				this.acceptedBarcodes[index].serials.push({
					value: baseCode + checkDigit,
					status: true,
					currentPrice: 0,
					localCurrentPrice: 0,
					localCurrentCode: "TL",
					currentPriceCode: "",
					sellerCurrentCode: "",
					sellerPrice: 0,
				});
			if (isDue == "excel") {
				obj = {
					barcode: barcode,
					qEntery: parseFloat(quantity),
					serials: this.acceptedBarcodes[index].serials,
				};
			} else {
				obj = {
					barcode: this.stockno,
					qEntery: parseFloat(this.selectedPerQty),
					serials: this.acceptedBarcodes[index].serials,
				};
			}
			this.$store.commit("stock/UPDATE_ACCEPTED_BARCODES", obj);

			if (this.acceptedBarcodes[index].SerialFollow == true)
				this.$store.commit("stock/UPDATE_ACCEPTED_BARCODES_SERIAL", obj);

			this.stockno = "";
			const vs = this.$vs;
			if (this.isMobile())
				vs.notify({
					text: "Eklendi",
					iconPack: "feather",
					icon: "icon-alert-circle",
					color: "success",
					position: "top-center",
				});
			setTimeout(() => {
				document.getElementById("barcodeId").focus();
			}, 500);
		},
		addBarcodeInCart(isDue, barcode, quantity, itemFExcel) {
			this.stockno = this.stockno.replace(/\?/g, "_");
			const vs = this.$vs;
			let today = new Date();
			let obj = {};
			if (isDue == "excel") {
				obj = {
					barcode: barcode,
					depotId: this.storehouse.value,
					depotName: this.storehouse.name,
					supplierName: this.supplier.name,
					supplierId: this.supplier.value,
					supplierCode: this.supplier.code,
					transactionNo: this.transactionNo,
					description: this.transactionDescription,
					customerName: this.customer.name,
					companyId: this.customer.value,
					createdDate: this.parseDate(today),
					quantity: parseFloat(quantity),
					transType: this.transType.value,
					serialParam: itemFExcel,
					isExcel: true,
				};
			} else {
				obj = {
					barcode: this.stockno,
					depotId: this.storehouse.value,
					depotName: this.storehouse.name,
					supplierName: this.supplier.name,
					supplierId: this.supplier.value,
					supplierCode: this.supplier.code,
					transactionNo: this.transactionNo,
					description: this.transactionDescription,
					customerName: this.customer.name,
					companyId: this.customer.value,
					createdDate: this.parseDate(today),
					quantity: parseFloat(this.selectedPerQty),
					transType: this.transType.value,
					transTypeName: this.transType.name,
				};
			}
			this.$store
				.dispatch("stock/listStockBarcodesForBarcode", obj)
				.then((response) => {
					if (response.success == true) {
						/*   if (response.message == "Stock list by master barcode") {
							console.log(JSON.parse(response.json));
							let stockBarcodeChoices = JSON.parse(response.json);
							this.barcode_choices = [];
							stockBarcodeChoices.forEach((val, index) => {
								this.barcode_choices.push({
									name: val.StockName,
									value: val.StockId,
									code: val.Stockno,
								});
							});
						} else {*/
						this.stockno = "";
						setTimeout(() => {
							document.getElementById("barcodeId").focus();
						}, 500);
						/*  let jsonParsed = JSON.parse(response.json);
						if (jsonParsed.SerialFollow == true) {
							jsonParsed.qEntry = jsonParsed.QEntry;
							this.createSerialNumberAcceptedBarcode(jsonParsed);
							console.log(this.dataForSerial);

							this.updateSerialInCart();
						}*/
						if (isDue != "excel")
							vs.notify({
								text: response.message,
								iconPack: "feather",
								icon: "icon-alert-circle",
								color: "success",
								position: "top-center",
							});
						//    }
					} else {
						if (isDue != "excel")
							vs.notify({
								text: response.data.message.toString(),
								iconPack: "feather",
								icon: "icon-alert-circle",
								color: "danger",
								position: "top-center",
							});
						else { this.errorExcels.push({ barcode: obj.barcode, serialParam: obj.serialParam, message: response.data.message == "undefined" ? "" : response.data.message.toString() }) }
					}
				})
				.catch((error) => {
					this.errorExcels.push({ barcode: obj.barcode, serialParam: obj.serialParam, message: response.data.message == "undefined" ? "" : response.data.message.toString() })
					return new Promise((resolve, reject) => {
						resolve(false);
					});
				});
			this.stockno = "";
		},
		filterStock() {
			const vs = this.$vs;

			if (this.transactionNo == "") {
				vs.notify({
					text: "Transfer numarası boş olamaz",
					iconPack: "feather",
					icon: "icon-alert-circle",
					color: "warning",
					position: "top-center",
				});
			} else {
				this.isInCart(this.stockno)
					? this.updateBarcodeInCart()
					: this.addBarcodeInCart();
			}
		},
		onGridReady2(params) {
			this.gridApi2 = params.api;
			this.gridColumnApi2 = params.columnApi;
		},
		onGridReady(params) {
			this.gridApi = params.api;
			this.gridColumnApi = params.columnApi;
		},
		getCustomerDepoList() {
			const vs = this.$vs;
			this.storehouse_choices = [];
			this.$store
				.dispatch("storehouse/listStorehouseAllValues2", this.customer.value)
				.then((response) => {
					// let costumerList = JSON.parse(response.json);
					if (response.success == true) {
						this.storehouseForCustomerList = this.storehouseForCompany;
						this.storehouseForCustomerList.forEach((val, index) => {
							this.storehouse_choices.push({ value: val.DepotId, name: val.DepotName });
						});
					} else console.log(response);
					/*	vs.notify({
						text: response.statusText,
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "danger",
						position: "top-center"
					});*/
				});
		},
		getTransTypeList(id, popup) {
			this.transTypeListOption = [];
			this.transType_choices = [];
			this.transTypeListOption = this.transTypes;
			this.transType_choices = Object.keys(this.transTypes).map((key) => {
				return {
					value: key,
					name: this.$t(this.transTypes[key]),
				};
			});
		},
		getCustomerList(id, popup) {
			this.customerListOption = [];
			this.customer_choices = [];
			this.customerListOption = this.companydata;
			this.customerListOption.forEach((val, index) => {
				this.customer_choices.push({ value: val.CompanyId, name: val.CompanyName });
			});
		},
		getacceptedBarcodesAllColumns() {
			this.acceptedBarcodesAllColumns = [];
			if (this.acceptedBarcodesAll && this.acceptedBarcodesAll.length > 0) {
				let columnList = Object.keys(this.acceptedBarcodesAll[0]);

				columnList.forEach((value, index) => {
					if (value == "qEntery" || value == "qExit")
						this.acceptedBarcodesAllColumns.push({
							headerName: this.$t(value),
							field: value,
							filter: "agSetColumnFilter",
							cellRendererFramework: "TextViewCellRenderer",
							pinned: "right",
						});
					else if (value.toString().includes("Date") == true) {
						this.acceptedBarcodesAllColumns.push({
							headerName: this.$t(value),
							field: value,
							filter: "agSetColumnFilter",
							cellRendererFramework: "TextViewCellRenderer",
							valueFormatter: this.parseDateAg,
						});
					} else if (value.toString().includes("Id") == false)
						this.acceptedBarcodesAllColumns.push({
							headerName: this.$t(value),
							field: value,
							filter: "agSetColumnFilter",
							cellRendererFramework: "TextViewCellRenderer",
						});
				});
			}
		},
		getBarcodesColumns() {
			this.acceptedBarcodesColumns = [];

			if (this.acceptedBarcodes && this.acceptedBarcodes.length > 0) {
				let columnList = Object.keys(this.acceptedBarcodes[0]);
				/*     this.acceptedBarcodesColumns.push({
					width: 100,
					pinned: "left",
					cellRendererFramework: "twoInfoButtonsDynamic",
					cellRendererParams: {
						detailMethodsOne: "deleteAcceptedBarcode",
						tooltipOne: "Delete",
						iconDetailOne: "ic:baseline-remove-circle",
						iconColorOne: "#fe6d73",

						detailMethodsTwo: "reduceAcceptedBarcode",
						tooltipTwo: "Reduce",
						iconDetailTwo: "akar-icons:reduce",
						iconColorTwo: "#fe6d73",
					},
				});*/
				this.acceptedBarcodesColumns.push({
					width: 170,
					pinned: "left",
					cellRendererFramework: "threeInfoButtonsDynamic",
					cellRendererParams: {
						detailMethodsOne: "deleteAcceptedBarcode",
						tooltipOne: "Delete",
						iconDetailOne: "ic:baseline-remove-circle",
						iconColorOne: "#fe6d73",

						detailMethodsTwo: "reduceAcceptedBarcode",
						tooltipTwo: "Reduce",
						iconDetailTwo: "akar-icons:reduce",
						iconColorTwo: "#fe6d73",

						detailMethodsTree: "createSerialNumberAcceptedBarcode",
						tooltipTree: "Create",
						iconDetailTree: "ix:product-management",
						iconColorTree: "#ffcb77",
					},
				});

				columnList.forEach((value, index) => {
					if (value == "qEntery" || value == "qExit")
						this.acceptedBarcodesColumns.push({
							headerName: this.$t(value),
							field: value,
							width: 70,

							filter: "agSetColumnFilter",
							cellRendererFramework: "stockAcceptancedCount",
							pinned: "right",
						});
					else if (value.toString().includes("Date") == true) {
						this.acceptedBarcodesAllColumns.push({
							headerName: this.$t(value),
							field: value,
							filter: "agSetColumnFilter",
							valueFormatter: this.parseDateAg,
						});
					} else if (value.toString().includes("Id") == false)
						this.acceptedBarcodesColumns.push({
							headerName: this.$t(value),
							field: value,
							filter: "agSetColumnFilter",
						});
				});
			}
		},
		reduceAcceptedBarcode(data) {
			let obj = {
				barcode: data.barcode,
				serial: data.serials,
			};
			if (data.SerialFollow)
				this.$store.commit("stock/REDUCE_ACCEPTED_BARCODES", obj);
		},
		createSerialNumberAcceptedBarcode(data) {
			if (data.SerialFollow == true) {
				this.isSerialNumberPopup = true;
				//   this.isSerialNumberPopup = true;
				this.dataForSerial = data;
				if (this.dataForSerial.serials) {
					if (this.dataForSerial.serials.length <= 0) {
						this.dataForSerial.serials = [];
						this.generateSerialNumbers();
					} else {
						this.generateSerialNumbers();
					}
				} else {
					this.dataForSerial.serials = [];
					this.generateSerialNumbers();
				}
			} else {
				const vs = this.$vs;

				vs.notify({
					text: this.$t("InfoAcceptedBarcodesSerial"),
					iconPack: "feather",
					icon: "icon-alert-circle",
					color: "warning",
					position: "top-center",
				});
			}
		},
	},
	created() {
		this.getBarcodesColumns();
		this.getCustomerList();
		this.getTransTypeList();
		this.getSupplierList();
		this.$store.commit("stock/REMOVE_ACCEPTED_ALL_BARCODES");

		if (this.$route.path == "/product-receipt") {
			this.transType = {
				value: "1",
				name: this.$t("Entrance"),
			};
			this.transTypeDisabled = true;
		}
		this.stockno = "";
		this.storehouse = "";
		this.customer = "";
		this.transactionNo = "";
		this.supplier = "";
		this.transactionDescription = "";
		if (this.acceptedBarcodes.length > 0) {
			this.barcodesUpdateControl = true;
			setTimeout(() => {
				document.getElementById("barcodeId").focus();
			}, 500);
			this.storehouse = {
				value: this.acceptedBarcodes[0].depotId,
				name: this.acceptedBarcodes[0].depotName,
			};
			this.supplier = {
				value: this.acceptedBarcodes[0].supplierId,
				name: this.acceptedBarcodes[0].supplierName,
				code: this.acceptedBarcodes[0].supplierCode,
			};
			this.transType = {
				value: this.acceptedBarcodes[0].transType,
				name: this.acceptedBarcodes[0].transTypeName,
			};
			this.customer = {
				value: this.acceptedBarcodes[0].companyId,
				name: this.acceptedBarcodes[0].companyName,
			};
			this.transactionNo = this.acceptedBarcodes[0].transCode;
			this.transactionDescription = this.acceptedBarcodes[0].description;
		}
	},
	watch: {
		supplierLc(val) {
			this.getSupplierList();

			return val;
		},
		transTypes(val) {
			this.getTransTypeList();
			return val;
		},
		storehouseForCompany(val) {
			return val;
		},
		acceptedBarcodes: {
			handler(val) {
				if (this.acceptedBarcodes.length > 0) {
					this.barcodesUpdateControl = true;
					this.totalQEntery = this.acceptedBarcodes.reduce(
						(total, item) => total + item.qEntery,
						0
					);
				}
				this.getBarcodesColumns();
				return val;
			},
			deep: true, // acceptedBarcodes içindeki değişiklikleri de izlemek için
		},
		companydata(val) {
			this.getCustomerList();
			return val;
		},
	},
	mounted() {
		this.$root.$on("addNewWithExcel", (paramDetail) => {
			if (paramDetail) this.isUploadedAddExcel = true;
			this.wholeAcceptedProductListAddExcel = paramDetail;
			this.setItem();
		});
		this.$root.$on("excelData", (paramDetail) => {
			if (paramDetail) this.isUploaded = true;
			this.wholeAcceptedProductList = paramDetail;
		});
		this.$root.$on("deleteSubmit", (data) => {
			this.deleteAll(data);
		});
		this.$root.$on("deleteAcceptedBarcode", (data) => {
			this.deletedData = data;
			this.isSidebarActiveDeleteFromList = true;
		});
		this.$root.$on("closeDeleteWarning", () => {
			this.closeDeleteWarning();
		});
		this.$root.$on("reduceAcceptedBarcode", (data) => {
			this.reduceAcceptedBarcode(data);
		});
		this.$root.$on("createSerialNumberAcceptedBarcode", (data) => {
			this.createSerialNumberAcceptedBarcode(data);
		});
	},
	beforeDestroy() {
		this.$root.$off("excelData");
		this.$root.$off("addNewWithExcel");

		this.$root.$off("closeDeleteWarning");
		this.$root.$off("deleteAcceptedBarcode");
		this.$root.$off("deleteSubmit");
		this.$root.$off("reduceAcceptedBarcode");
		this.$root.$off("createSerialNumberAcceptedBarcode");
	},
	computed: {
		supplierLc: {
			get() {
				return this.$store.state.customer.Supplier;
			},
			set(val) {
				if (!val) {
				}
			},
		},
		isInCart() {
			return (itemId) => this.$store.getters["stock/isInCart"](itemId);
		},
		transTypes: {
			get() {
				return this.$store.state.stock.StockTransType;
			},
			set(val) {
				if (!val) {
				}
			},
		},
		acceptedBarcodes: {
			get() {
				return this.$store.state.stock.AcceptedBarcodes;
			},
			set(val) {
				if (!val) {
				}
			},
		},
		storehouseForCompany: {
			get() {
				return this.$store.state.storehouse.Storehouse;
			},
			set(val) {
				if (!val) {
				}
			},
		},
		companydata: {
			get() {
				return this.$store.state.customer.Customer;
			},
			set(val) {
				if (!val) {
				}
			},
		},
		localeText() {
			return i18nData[this.$i18n.locale];
		},
	},
};
</script>
<style lang="scss">
.con-vs-dialog {
	z-index: 520055;
}
</style>
<style lang="scss" scoped>
.con-vs-popup .vs-popup {
	width: 1000px !important;
}
</style>
